import React from 'react';
import { Link } from 'react-router-dom';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const Footer = () => {
  return (
    <footer className="bg-brand-navy text-white flex flex-col">
      {/* Global Bottom Banner */}
      <div className="bg-brand-green text-white py-4 px-4 text-center font-bold text-lg sm:text-xl shadow-md border-b border-brand-navy/20 tracking-wide">
        Helping clients build safe and efficient operations for 19 years
      </div>

      <div className="py-16 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full border-t-4 border-brand-navy">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-8">
          <div className="lg:col-span-1">
            <Link to="/" className="inline-block mb-6 bg-white p-3 rounded-xl shadow-lg">
              <img 
                src="https://media-manager-c.questera.ai/greta-media/e842e0d41a21d55020287eff0799ef371d19c38aa92b057bb3ca6b830a67458ee61195b657411aeb9534fd09dfbbea8f/images/aW1hZ2UvcG5n/2eef99af68f71a4e5d50808daf0f01df.png" 
                alt="Boes & Boes Training Consultants" 
                className="h-20 w-auto object-contain" 
              />
            </Link>
            <p className="text-sm text-slate-300 mb-6 leading-relaxed font-medium">
              Practical plans, training, and leadership programs built around your people, risks, and operations.
            </p>
            <div className="flex flex-col gap-2 text-xs text-slate-400">
              <span><strong>CAGE:</strong> 9UV45</span>
              <span><strong>UEI:</strong> JXU6AB8GAPE7</span>
              <span><strong>NAICS:</strong> 922190, 611430, 624230, 541612, 611710</span>
            </div>
          </div>

          <div>
            <h3 className="text-white font-bold mb-4 uppercase text-sm tracking-wider">Services</h3>
            <ul className="space-y-3 text-sm font-medium text-slate-300">
              <li><Link to="/services/emergency-planning" className="hover:text-brand-green transition-colors">Emergency Planning</Link></li>
              <li><Link to="/services/compliance-consulting" className="hover:text-brand-green transition-colors">Compliance Consulting</Link></li>
              <li><Link to="/services/drills-exercises" className="hover:text-brand-green transition-colors">Drills & Exercises</Link></li>
              <li><Link to="/services/training-development" className="hover:text-brand-green transition-colors">Training & Development</Link></li>
              <li><Link to="/services/leadership-development" className="hover:text-brand-green transition-colors">Leadership Development</Link></li>
            </ul>
          </div>

          <div>
            <h3 className="text-white font-bold mb-4 uppercase text-sm tracking-wider">Company</h3>
            <ul className="space-y-3 text-sm font-medium text-slate-300">
              <li><Link to="/about" className="hover:text-brand-green transition-colors">Our Story</Link></li>
              <li><Link to="/training/catalog" className="hover:text-brand-green transition-colors">Course Catalog</Link></li>
              <li><Link to="/experience" className="hover:text-brand-green transition-colors">Experience</Link></li>
              <li><Link to="/industries" className="hover:text-brand-green transition-colors">Industries</Link></li>
              <li><Link to="/resources" className="hover:text-brand-green transition-colors">Resources</Link></li>
            </ul>
          </div>

          <div>
            <h3 className="text-white font-bold mb-4 uppercase text-sm tracking-wider">Contact</h3>
            <ul className="space-y-4 text-sm font-medium text-slate-300">
              <li className="flex items-start gap-3">
                <SafeIcon icon={FiIcons.FiMapPin} className="text-brand-green mt-1 shrink-0 text-lg" />
                <span>Fort Wayne, Indiana<br/><span className="text-slate-400 font-normal">Serving Local, National & International Clients</span></span>
              </li>
              <li className="flex items-center gap-3">
                <SafeIcon icon={FiIcons.FiPhone} className="text-brand-green shrink-0 text-lg" />
                <a href="tel:+12602227827" className="hover:text-brand-green transition-colors">+1 260 222 7827</a>
              </li>
              <li className="flex items-center gap-3">
                <SafeIcon icon={FiIcons.FiMail} className="text-brand-green shrink-0 text-lg" />
                <a href="mailto:info@boesandboes.com" className="hover:text-brand-green transition-colors">info@boesandboes.com</a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-white/10 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-sm text-slate-400 font-medium text-center md:text-left">
            &copy; {new Date().getFullYear()} Boes & Boes Training Consultants LLC. All rights reserved.
          </p>
          <div className="flex space-x-6 text-sm font-medium">
            <Link to="/contact" className="text-slate-400 hover:text-brand-green transition-colors">Contact</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;